import React, { Component, Fragment } from "react";
import "./sizing.css";
import DropDownWhiteStyle from "../../components/dropdown/dropDownWhiteStyle";
import { Link } from "react-router-dom";
import {
    getInletCNGPressure,
    getCNG4Capacity,
    getCNG17Capacity,
} from "../../constants/sizing-constant";


export default class GasPistoonCNGSizing extends Component {

    state = {
        inletCNGPressure: [],
        selectedInletCNGPressure: "0",

        capacity: [],
        selectedCapacity: "0",

        suggestedModel: "",
        suggestedModelId: "",
        suggestedModelPower: "",
        sentrifuge: []
    };

    componentDidMount() {
        this.setState({ inletCNGPressure: [...getInletCNGPressure()] });
    };

    componentWillReceiveProps(Values) {
        this.setState({ products: Values.products });
    };

    handleInletCNGPressureSelect = inletCNGPressure => {
        if (inletCNGPressure) {
            this.setState({ selectedInletCNGPressure: inletCNGPressure.value }, () => { });
            this.setState({ suggestedModel: "" }, () => { });
            if (inletCNGPressure.value === "1")
                this.setState({ capacity: [...getCNG4Capacity()] });
            if (inletCNGPressure.value === "2")
                this.setState({ capacity: [...getCNG17Capacity()] });
        }
    };

    handleCapacitySelect = capacity => {
        if (capacity) {
            this.setState({ selectedCapacity: capacity.value }, () => {
                this.findModel();
            });
        }
    };

    findModel() {
        const selectedInletCNGPressure = this.state.selectedInletCNGPressure;
        const selectedCapacity = this.state.selectedCapacity;
        if (selectedInletCNGPressure !== "") {
            if (selectedInletCNGPressure === "1") {
                if (selectedCapacity === "1") {
                    this.setState({ suggestedModel: "4 استیج-HCC 500" });
                    this.setState({ suggestedModelId: "91" });
                    this.setState({ suggestedModelPower: "110" });
                }
                else if (selectedCapacity === "2") {
                    this.setState({ suggestedModel: "HCC 750" });
                    this.setState({ suggestedModelId: "92" });
                    this.setState({ suggestedModelPower: "165" });
                }
                else if (selectedCapacity === "3") {
                    this.setState({ suggestedModel: "4 استیج-HCC 1000" });
                    this.setState({ suggestedModelId: "93" });
                    this.setState({ suggestedModelPower: "220" });
                }
            }
            else if (selectedInletCNGPressure === "2") {
                if (selectedCapacity === "1") {
                    this.setState({suggestedModel: "3 استیج-HCC 500"});
                    this.setState({ suggestedModelId: "94" });
                    this.setState({ suggestedModelPower: "75" });
                }
                else if (selectedCapacity === "2") {
                    this.setState({suggestedModel: "3 استیج-HCC 1000"});
                    this.setState({ suggestedModelId: "95" });
                    this.setState({ suggestedModelPower: "150" });
                }
                else if (selectedCapacity === "3") {
                    this.setState({ suggestedModel: "HCC 1200" });
                    this.setState({ suggestedModelId: "96" });
                    this.setState({ suggestedModelPower: "165" });
                }
                else if (selectedCapacity === "4") {
                    this.setState({ suggestedModel: "HCC 1500" });
                    this.setState({ suggestedModelId: "97" });
                    this.setState({ suggestedModelPower: "220" });
                }
                else if (selectedCapacity === "5") {
                    this.setState({ suggestedModel: "HCC 2000" });
                    this.setState({ suggestedModelId: "98" });
                    this.setState({ suggestedModelPower: "280" });
                }
            }
        }
    }

    render() {
        return (
            <Fragment>
                <DropDownWhiteStyle
                    items={this.state.inletCNGPressure}
                    placeholder="فشار ورودی (برحسب مترمکعب بر ساعت) بار"
                    onItemSelect={this.handleInletCNGPressureSelect}
                />
                {this.state.selectedInletCNGPressure !== "0" &&

                    <DropDownWhiteStyle
                        items={this.state.capacity}
                        placeholder="ظرفیت بر حسب نرمال متر مکعب"
                        onItemSelect={this.handleCapacitySelect}
                    />
                }
                {this.state.suggestedModel !== "" &&
                    <Fragment>      
                        <h1 className="text-title-body">مدل پیشنهادی برای شما :</h1>
                        <div className="modelheadbox">
                            <h1 >{this.state.suggestedModel}</h1>
                            <hr className="divider" />
                        </div>
                        <h3 className="text-title-description">فشار خروجی کمپرسور : ۲۲۵ Bar g</h3>
                        <h3 className="text-title-description">قدرت موتور : {this.state.suggestedModelPower} (kw)</h3>
                        <h3 className="text-title-description">Lubricated</h3>
                        <h3 className="text-title-description">مدل خنک شوندگی : هوا خنک</h3>
                        <h3 className="text-title-description">نوع کوپلینگ : Direct</h3>
                        <div className="row hrow mt-4">
                            <Link className="btn btn-dark" to={`/partRequst/${this.state.suggestedModelId}`} >درخواست خرید این مدل</Link>
                        </div>
                    </Fragment>
                }
            </Fragment>
        );
    }
}
